import axios from "axios";

const baseURL = process.env.VUE_APP_API_URL;

axios.defaults.withCredentials = true;
axios.defaults.baseURL = baseURL;

// const instance = axios.create({
//   baseURL,
//   headers: {
//     "Content-type": "application/json",
//   },
//   withCredentials: true,
// });

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 404) {
      window.location.href = "/404";
    }
    return Promise.reject(error);
  }
);

export default axios;
